import type { Client, PurchaseOrder, Business } from '@/lib/api';
import { purchaseOrderApi } from '@/lib/api';
import { SendDocumentModal } from './SendDocumentModal';

interface SendPurchaseOrderModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  purchaseOrder: PurchaseOrder;
  vendor: Client | null;
  business: Business | null;
  onSend: (data: {
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    message: string;
    cc_self: boolean;
  }) => Promise<void>;
}

export function SendPurchaseOrderModal({
  open,
  onOpenChange,
  purchaseOrder,
  vendor,
  business,
  onSend,
}: SendPurchaseOrderModalProps) {
  return (
    <SendDocumentModal
      open={open}
      onOpenChange={onOpenChange}
      documentType="purchase_order"
      documentId={purchaseOrder.id}
      documentNumber={purchaseOrder.purchase_order_number || purchaseOrder.id}
      noteForClient={purchaseOrder.note_for_vendor}
      client={vendor}
      business={business}
      getSendTemplate={purchaseOrderApi.getSendTemplate}
      onSend={onSend}
    />
  );
}
